import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { CREDITS_PER_TIER, formatCreditPrice, TIERS_WITH_SPECIAL_OFFER } from "constants/pricing/credits-config";
import { StyledCreditsSpecialOffer } from "./credits-special-offer.scss";
const CreditsSpecialOffer = ({ tierName, period, currency, seats })=>{
    const { translate, localeId } = useContext(GenericConfigContext);
    const isOfferTier = TIERS_WITH_SPECIAL_OFFER.includes(tierName);
    const showOffer = isOfferTier && (seats === undefined || seats < 20) && period !== "monthly";
    const offerCredits = CREDITS_PER_TIER[tierName] || 0;
    const offerLabel = formatCreditPrice({
        credits: offerCredits,
        period,
        currency,
        localeId
    });
    const offerTemplate = translate("pricingPage.credits.specialOffer") || "";
    const [beforeAmount, afterAmount] = offerTemplate.split("{amount}");
    if (period === "monthly") return null;
    return /*#__PURE__*/ _jsxs(StyledCreditsSpecialOffer, {
        className: "credits-special-offer",
        style: showOffer ? undefined : {
            visibility: "hidden"
        },
        children: [
            beforeAmount,
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx("strong", {
                children: offerLabel
            }),
            afterAmount
        ]
    });
};
export default CreditsSpecialOffer;
